module.exports = __webpack_public_path__ + "build/assets/TruenoRg-1f370f82260c35703a075fd991cc3c97.woff";